import React, { useState } from "react";
import {
    Container, Grid, Card, Inset, Heading, Text, Flex, Box, Badge, Button,
    Separator, TextField, TextArea, Select, Checkbox, RadioGroup, Switch, Slider,
    Dialog, DropdownMenu, Tooltip, Tabs, Callout
} from "@radix-ui/themes";
import {
    TrashIcon, MixerHorizontalIcon, ChevronDownIcon, CheckCircledIcon, InfoCircledIcon
} from "@radix-ui/react-icons";
// import '@radix-ui/themes/styles.css';


export function DemoPage() {
    var products = [
        { name: "Hodiny Risko", price: 200, category: "hodiny", img: "/images/hodiny3.png" },
        { name: "Hodiny Dub",   price: 149, category: "hodiny", img: "/images/placeholder.jpg" },
        { name: "Hodiny Borovica", price: 179, category: "hodiny", img: "/images/placeholder.jpg" }
    ];

    var [openModal, setOpenModal] = useState(false);
    var [qty, setQty] = useState([1]); // Slider
    var [newsletter, setNewsletter] = useState(true);

    function handleAdd(p) {
        alert("Do košíka: " + p.name);
    }

    function handleOpenModal() {
        setOpenModal(true);
    }

    function handleCloseModal() {
        setOpenModal(false);
    }

    return (
        <Box p="4">
            <Container size="3">
                <Heading size="8" mb="1">MČ WOODDESIGN</Heading>
                <Text size="4" color="gray">výroba drevených dekorácií</Text>

                <Separator my="4" />

                {/* KARTY PRODUKTOV */}
                <Grid columns={{ initial: "1", sm: "2", md: "3" }} gap="4" mb="5">
                    {products.map(function(p) {
                        return (
                            <Card key={p.name} style={{ overflow: "hidden" }}>
                                <Inset clip="padding-box" side="top" pb="current">
                                    <img src={p.img} alt={p.name} style={{ width: "100%", height: 220, objectFit: "cover" }} />
                                </Inset>

                                <Flex align="start" justify="between" mt="3" mb="1">
                                    <Heading size="4">{p.name}</Heading>
                                    <Badge color="brown" variant="soft">{p.category}</Badge>
                                </Flex>

                                <Text color="gray" mb="3">
                                    Ručne robené drevené hodiny s prírodnou textúrou.
                                </Text>

                                <Flex align="center" justify="between">
                                    <Heading size="5">{p.price.toFixed(2)} €</Heading>
                                    <Button onClick={function(){ handleAdd(p); }}>
                                        <TrashIcon />&nbsp;Do košíka
                                    </Button>
                                </Flex>
                            </Card>
                        );
                    })}
                </Grid>

                <Separator my="5" />

                {/* FORM / OVLÁDACIE PRVKY */}
                <Heading size="6" mb="3">Formulár (Radix UI Themes)</Heading>

                <Tabs.Root defaultValue="zaklad" mb="4">
                    <Tabs.List>
                        <Tabs.Trigger value="zaklad">Základ</Tabs.Trigger>
                        <Tabs.Trigger value="pokrocile">Pokročilé</Tabs.Trigger>
                    </Tabs.List>

                    <Tabs.Content value="zaklad" mt="3">
                        <Grid columns={{ initial: "1", md: "2" }} gap="4">
                            <Box>
                                <Text as="label" size="2" mb="1" style={{ display: "block" }}>Názov produktu</Text>
                                <TextField.Root placeholder="Napr. Hodiny Risko" />
                            </Box>

                            <Box>
                                <Text as="label" size="2" mb="1" style={{ display: "block" }}>Kategória</Text>
                                <Select.Root defaultValue="hodiny">
                                    <Select.Trigger />
                                    <Select.Content>
                                        <Select.Item value="hodiny">Hodiny</Select.Item>
                                        <Select.Item value="doplnky">Doplnky</Select.Item>
                                        <Select.Item value="darcek">Darčeky</Select.Item>
                                    </Select.Content>
                                </Select.Root>
                            </Box>

                            <Box>
                                <Text as="label" size="2" mb="1" style={{ display: "block" }}>Popis</Text>
                                <TextArea placeholder="Krátky popis produktu…" />
                            </Box>

                            <Box>
                                <Text as="label" size="2" mb="1" style={{ display: "block" }}>Cena (€)</Text>
                                <TextField.Root placeholder="0.00" type="number" />
                            </Box>
                        </Grid>

                        <Flex align="center" gap="4" mt="4" wrap="wrap">
                            <Flex align="center" gap="2">
                                <Checkbox defaultChecked id="skladom" />
                                <Text as="label" htmlFor="skladom">Skladom</Text>
                            </Flex>

                            <RadioGroup.Root defaultValue="m">
                                <Flex align="center" gap="3">
                                    <Flex align="center" gap="2"><RadioGroup.Item value="s" id="size-s" /><Text as="label" htmlFor="size-s">S</Text></Flex>
                                    <Flex align="center" gap="2"><RadioGroup.Item value="m" id="size-m" /><Text as="label" htmlFor="size-m">M</Text></Flex>
                                    <Flex align="center" gap="2"><RadioGroup.Item value="l" id="size-l" /><Text as="label" htmlFor="size-l">L</Text></Flex>
                                </Flex>
                            </RadioGroup.Root>

                            <Flex align="center" gap="2">
                                <Switch checked={newsletter} onCheckedChange={function(v){ setNewsletter(v); }} />
                                <Text>Odoberať novinky</Text>
                            </Flex>
                        </Flex>

                        <Box mt="4">
                            <Text size="2" mb="2" style={{ display: "block" }}>Počet kusov</Text>
                            <Slider defaultValue={qty} max={10} step={1} onValueChange={function(v){ setQty(v); }} />
                            <Text size="2" color="gray">Aktuálne: {qty[0]} ks</Text>
                        </Box>

                        <Flex gap="3" mt="4">
                            <Button>
                                <MixerHorizontalIcon />&nbsp;Uložiť
                            </Button>

                            <DropdownMenu.Root>
                                <DropdownMenu.Trigger>
                                    <Button variant="soft">
                                        <ChevronDownIcon />&nbsp;Viac akcií
                                    </Button>
                                </DropdownMenu.Trigger>
                                <DropdownMenu.Content>
                                    <DropdownMenu.Item>Duplikovať</DropdownMenu.Item>
                                    <DropdownMenu.Item>Skryť</DropdownMenu.Item>
                                    <DropdownMenu.Separator />
                                    <DropdownMenu.Item color="red">Zmazať</DropdownMenu.Item>
                                </DropdownMenu.Content>
                            </DropdownMenu.Root>

                            <Dialog.Root open={openModal} onOpenChange={function(v){ setOpenModal(v); }}>
                                <Dialog.Trigger>
                                    <Button variant="soft" color="brown" onClick={handleOpenModal}>Náhľad</Button>
                                </Dialog.Trigger>
                                <Dialog.Content maxWidth="520px">
                                    <Dialog.Title>Náhľad produktu</Dialog.Title>
                                    <Dialog.Description>Takto sa produkt zobrazí v ponuke.</Dialog.Description>

                                    <Card mt="3">
                                        <Inset clip="padding-box" side="top" pb="current">
                                            <img src="/images/hodiny3.png" alt="Náhľad" style={{ width: "100%", height: 220, objectFit: "cover" }} />
                                        </Inset>
                                        <Flex align="start" justify="between" mt="3" mb="1">
                                            <Heading size="4">Hodiny Risko</Heading>
                                            <Badge color="brown" variant="soft">hodiny</Badge>
                                        </Flex>
                                        <Text color="gray" mb="3">Ručná výroba, prírodné drevo.</Text>
                                        <Flex align="center" justify="between">
                                            <Heading size="5">200.00 €</Heading>
                                            <Button onClick={handleCloseModal}>
                                                <CheckCircledIcon />&nbsp;OK
                                            </Button>
                                        </Flex>
                                    </Card>

                                    <Flex gap="3" mt="4" justify="end">
                                        <Dialog.Close>
                                            <Button variant="soft">Zavrieť</Button>
                                        </Dialog.Close>
                                    </Flex>
                                </Dialog.Content>
                            </Dialog.Root>
                        </Flex>

                        <Callout.Root color="green" mt="4">
                            <Callout.Icon><InfoCircledIcon /></Callout.Icon>
                            <Callout.Text>Všetko vyššie je čisto Radix UI Themes – bez Bootstrapu.</Callout.Text>
                        </Callout.Root>
                    </Tabs.Content>

                    <Tabs.Content value="pokrocile" mt="3">
                        <Text color="gray">Sem vieme doplniť ďalšie komponenty (Popover, Table, DataList …) ak budeš chcieť.</Text>
                    </Tabs.Content>
                </Tabs.Root>

                <Tooltip content="Len ukážka">
                    <Button variant="outline">Tooltip na tlačidle</Button>
                </Tooltip>
            </Container>
        </Box>
    );
}
